import {
  IAuditWebServiceClient,
  NaturePrelevementDto,
  RechercheExamenDto,
  SpecialiteExamenDto,
  TarificationNabmDto,
  TechniqueExamenDto,
  TemperatureEnum,
  RechercheWithHighlightDto
} from "@resources/resources";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Component, EventEmitter, Output } from "@angular/core";
import * as lodash from "lodash";
import {FiltreItem} from "./vos-filtres/filtre-item";
import {Subscription} from "rxjs";
import { UserStore } from "@digicerba/common";

@Component({
  selector: 'filtres-catalogue',
  templateUrl: './filtres-catalogue.component.html',
  host: { 'class': 'filter' }
})
export class FiltresCatalogueComponent {

  filterForm: FormGroup;
  lettres: Array<String>;

  natures: Array<NaturePrelevementDto>;
  specialites: Array<SpecialiteExamenDto>;
  techniques: Array<TechniqueExamenDto>;
  temperatures: Array<TemperatureEnum>;
  tarifications: Array<String>;
  tarificationsNabm: Array<TarificationNabmDto>;
  tags: Array<string>;

  @Output() onFiltering = new EventEmitter<RechercheWithHighlightDto>();
  filtres = new Array<FiltreItem>();

  subscr: Subscription;

  constructor(fb: FormBuilder, private activatedRoute: ActivatedRoute, private auditWebServiceClient: IAuditWebServiceClient, private userStore: UserStore) {

    this.filterForm = fb.group({
      favori: false,
      examen: null,
      lettreSelected: null,
      natureSelected: null,
      specialiteSelected: null,
      techniqueSelected: null,
      temperatureSelected: null,
      tarificationSelected: null,
      tarificationNabmSelected: null
    });

    this.lettres = 'abcdefghijklmnopqrstuvwxyz0123456789'.split('');

    let catalogueExamenFiltresDto = this.activatedRoute.snapshot.data['filtres'];

    this.natures = catalogueExamenFiltresDto.natures;
    this.specialites = catalogueExamenFiltresDto.specialites;
    this.techniques = catalogueExamenFiltresDto.techniques;
    this.temperatures = catalogueExamenFiltresDto.temperatures;
    this.tarificationsNabm = catalogueExamenFiltresDto.tarifications.sort((a, b) => a.code - b.code);

    this.tarificationsNabm.forEach(tarif => {
      tarif.code = "" + tarif.code;
      if (tarif.code.length < 4) {
        tarif.code = "0000".substring(tarif.code.length) + tarif.code;
      }
      tarif.libelle = tarif.code + " - " + tarif.libelle;
    });

    this.tarifications = new Array<String>();
    this.tarifications.push("NABM");
    this.tarifications.push("HN");

    this.subscr = this.filterForm.valueChanges.debounceTime(900).subscribe(data => {
      if ((data.tarificationSelected == "NABM" && !data.tarificationNabmSelected)) {
        return;
      }
      this.submit();
    })

    this.tags = this.activatedRoute.snapshot.data['tags'];

    this.activatedRoute.queryParams.subscribe(params => {
      let favoriParam = params['favori'];
      if (favoriParam) {
        this.filterForm.value.favori = true;
      }
    });
  }

  isFr(): boolean {
    if (lodash.indexOf(this.tags, "fr") != -1) {
      if (lodash.indexOf(this.tags, "en") == -1) {
        return true;
      }
    }
    return false;
  }

  isNabm(): boolean {
    if (this.filterForm.value.tarificationSelected == "NABM") {
      return true;
    }
    return false;
  }

  icon(temperature: string): string {
    if (temperature == "CONGELE") {
      return "fa-snowflake-o";
    } else if (temperature == "REFRIGERE") {
      return "fa-tint";
    } else if (temperature == "AMBIANT") {
      return "fa-sun-o";
    }
    return null;
  }

  chooseLetter(lettre: string): void {
    this.filterForm.get('lettreSelected').setValue(lettre);
  }

  submit() {
    this.buildFiltering();
    let rechercheWithHighlightDto = new RechercheWithHighlightDto();
    let terms = this.getTermsToHighlight();
    rechercheWithHighlightDto.termsToHighlight = terms;
    rechercheWithHighlightDto.rechercheExamenDto = this.initRechercheDto();
    this.onFiltering.emit(rechercheWithHighlightDto);
  }

  //======= Gestion des filtres =======
  onRemove(filtre: FiltreItem) {
    if (filtre.field == 'examen') {
      let favori = this.filterForm.value.favori;
      this.filterForm.reset({
        favori: favori
      });
    }

    lodash.remove(this.filtres, (obj) => {
      return obj == filtre;
    });

    let rechercheWithHighlightDto = new RechercheWithHighlightDto();
    let terms = this.getTermsToHighlight();
    rechercheWithHighlightDto.termsToHighlight = terms != null ? terms : '';
    rechercheWithHighlightDto.rechercheExamenDto = this.initRechercheDto();
    this.onFiltering.emit(rechercheWithHighlightDto);
  }

  private initRechercheDto(): RechercheExamenDto {
    let rechercheExamenDto = new RechercheExamenDto();

    this.filtres.forEach(f => {
      if (f.field == 'favori') {
        rechercheExamenDto.favori = f.value;
      }
      else if (f.field == 'lettre') {
        rechercheExamenDto.lettre = f.value;
      }
      else if (f.field == 'examen') {
        rechercheExamenDto.examen = f.value;
      }
      else if (f.field == 'nature') {
        if (rechercheExamenDto.natures == null) {
          rechercheExamenDto.natures = [];
        }
        rechercheExamenDto.natures.push(f.value);
      }
      else if (f.field == 'specialite') {
        if (rechercheExamenDto.specialites == null) {
          rechercheExamenDto.specialites = [];
        }
        rechercheExamenDto.specialites.push(f.value);
      }
      else if (f.field == 'technique') {
        if (rechercheExamenDto.techniques == null) {
          rechercheExamenDto.techniques = [];
        }
        rechercheExamenDto.techniques.push(f.value);
      }
      else if (f.field == 'temperature') {
        if (rechercheExamenDto.temperatures == null) {
          rechercheExamenDto.temperatures = [];
        }
        rechercheExamenDto.temperatures.push(f.value);
      }
      else if (f.field == 'tarification') {
        if (rechercheExamenDto.tarifications == null) {
          rechercheExamenDto.tarifications = [];
        }
        rechercheExamenDto.tarifications.push(f.value);
      }
    });

    return rechercheExamenDto;
  }

  buildFiltering() {
    let formValues = this.filterForm.value;

    if (formValues.favori != null) {
      let favori = this.filtres.find(f => f.field == 'favori');
      if (favori != null) {
        favori.value = formValues.favori;
      }
      else {
        this.filtres.push(new FiltreItem('favori', null, formValues.favori));
      }
    }

    lodash.remove(this.filtres, function (o) {
      return o.field == 'examen';
    })

    if (formValues.examen) {
      this.filtres.push(new FiltreItem('examen', formValues.examen, formValues.examen));
    }

    if (formValues.lettreSelected) {
      lodash.remove(this.filtres, function (o) {
        return o.field == 'lettre';
      });
      this.filtres.push(new FiltreItem('lettre', formValues.lettreSelected, formValues.lettreSelected));
    }

    if (formValues.natureSelected) {
      this.filtres.push(new FiltreItem('nature', formValues.natureSelected.libelle, formValues.natureSelected));
    }

    if (formValues.specialiteSelected) {
      this.filtres.push(new FiltreItem('specialite', formValues.specialiteSelected.libelle, formValues.specialiteSelected));
    }

    if (formValues.techniqueSelected) {
      this.filtres.push(new FiltreItem('technique', formValues.techniqueSelected.libelle, formValues.techniqueSelected));
    }

    if (formValues.temperatureSelected) {
      this.filtres.push(new FiltreItem('temperature', "CATALOGUE.FILTRE.TEMPERATURE." + formValues.temperatureSelected, formValues.temperatureSelected));
    }

    if (formValues.tarificationSelected) {
      let tarification = formValues.tarificationSelected;

      if (tarification == "NABM") {
        if (formValues.tarificationNabmSelected && formValues.tarificationNabmSelected.code != null) {
          let value = formValues.tarificationNabmSelected.code;
          let displayName = formValues.tarificationNabmSelected.libelle;
          this.filtres.push(new FiltreItem('tarification', displayName, value));
        }
      }
      else {
        let value = formValues.tarificationSelected;
        let displayName = formValues.tarificationSelected;
        this.filtres.push(new FiltreItem('tarification', displayName, value));
      }
    }

    this.subscr.unsubscribe();

    this.filterForm.reset({
      favori: formValues.favori,
      examen: formValues.examen
    }, false);

    this.subscr = this.filterForm.valueChanges.debounceTime(900).subscribe(data => {
      if ((data.tarificationSelected == "NABM" && !data.tarificationNabmSelected)) {
        return;
      }
      this.submit();
    });

    this.logAuditFiltre();
  }

  logAuditFiltre() {
    let messageAudit = "Client " + this.userStore.getUser().login + " - Recherche catalogue – ";
    this.filtres.forEach((filtre, index) => {
      if (index > 0) {
        messageAudit += ", ";
      }
      messageAudit += filtre.displayName + "=" + filtre.value;
    });

    this.auditWebServiceClient.info({message: messageAudit}).subscribe(() => {
    });
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == 'INVITE';
  }

  getTermsToHighlight(): string {
    let termsToHighlight;

    let termsFilter = lodash.find(this.filtres, ((filtre) => {
      if (filtre.field == 'examen') {
        return filtre;
      } else {
        return null;
      }
    }));

    if (termsFilter != null) {
      termsToHighlight = termsFilter.value.toString();
    } else {
      termsToHighlight = '';
    }
    return termsToHighlight;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/filtres/filtres-catalogue.component.ts